/* WobbleBag product details: accessible tabs (click + arrow/Home/End keys). */
if (!customElements.get('wb-product-details')) {
  customElements.define(
    'wb-product-details',
    class WbProductDetails extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-detail-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-detail-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        const key = this.tabs[index].dataset.detailTab;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.detailPanel !== key;
        });
      }
    }
  );
}
